import * as yup from "yup";
import moment from "moment";

yup.addMethod(yup.string, "minValue", function (args) {
  const { errorMessage, min } = args;
  return this.test(`check-min`, errorMessage, function (value) {
    const { path, createError } = this;

    if (!value) return true;

    const intValue = parseInt(value.replaceAll(",", ""));

    return (
      intValue >= parseInt(min) || createError({ path, message: errorMessage })
    );
  });
});

yup.addMethod(yup.string, "maxValue", function (args) {
  const { errorMessage, max } = args;
  return this.test(`check-max`, errorMessage, function (value) {
    const { path, createError } = this;

    if (!value) return true;

    const intValue = parseInt(value.replaceAll(",", ""));

    return (
      intValue <= parseInt(max) || createError({ path, message: errorMessage })
    );
  });
});

yup.addMethod(yup.string, "minmax", function (args) {
  const { errorMessage, max, min } = args;
  return this.test(`check-minmax`, errorMessage, function (value) {
    const { path, createError } = this;

    return (
      (value <= parseInt(max) && value >= parseInt(min)) ||
      createError({ path, message: errorMessage })
    );
  });
});

const fullNameRegex = /^[a-zA-Z. ]*$/;

yup.addMethod(yup.string, "fullName", function (args) {
  const { errorMessage } = args;
  return this.test("check-full-name", errorMessage, function (fullName) {
    const { path, createError } = this;
    return (
      (fullName.match(fullNameRegex) && fullName.split(" ").length > 1) ||
      fullName.split(".").length > 1 ||
      createError({ path, message: errorMessage })
    );
  });
});

yup.addMethod(yup.string, "minYears", function (args) {
  const { errorMessage, minYears } = args;
  return this.test("check-min-date", errorMessage, function (givenDate) {
    const { path, createError } = this;
    const years = moment().diff(givenDate, "years", false);
    console.log(years, minYears);
    return years >= minYears || createError({ path, message: errorMessage });
  });
});

yup.addMethod(yup.string, "maxYears", function (args) {
  const { errorMessage, maxYears } = args;
  return this.test("check-max-date", errorMessage, function (givenDate) {
    const { path, createError } = this;
    const years = moment().diff(givenDate, "years", false);
    console.log(years, maxYears);
    return years <= maxYears || createError({ path, message: errorMessage });
  });
});

export { yup };
